module.exports = __webpack_public_path__ + "img/symbol_3.0c400b25.png";